module.exports = __webpack_public_path__ + "05c18390ff32a15c47e0f26c519eb657.svg";